module.exports = __webpack_public_path__ + "static/media/WelcomeImage2020.0dbec3ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/WelcomeImage2020.png
// module id = 345
// module chunks = 0